import React from 'react'

import { Wrapper, Spinner } from './styled'

/**
 * Заглушка, пока подгружается чанк страницы.
 *
 * Появляется на доли секунды и только при первом заходе на раздел, поэтому
 * намеренно скучная: спиннер без текста. Любая надпись успеет мигнуть и
 * прочитаться не успеет.
 */
const RouteFallback = () => (
  <Wrapper>
    <Spinner />
  </Wrapper>
)

export default RouteFallback
